<template>
  <div>
    <div v-if="!twofa_recovery_new_token">
      <form
        ref="card"
        @submit.prevent="auth(value)"
        :class="{'box-loading': loading}">
        <div v-if="!value.twofa_type">
          <h4 class="mb-3">Bem-vindo!</h4>
          <p>Faça login com seu email e senha para acessar sua conta.</p>
          <div class="form-group">
            <label>{{ $t('Email') }}</label>
            <input
              v-autofocus
              type="text"
              class="form-control"
              v-model="value.email">
            <ValidateMessage :error="validateErrors.email" />
          </div>
          <div class="form-group">
            <label>{{ $t('Password') }}</label>
            <input
              type="password"
              class="form-control"
              v-model="value.password">
            <ValidateMessage :error="validateErrors.password" />
          </div>
          <div class="form-group">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="remember_me"
                v-model="value.remember_me">
              <label
                class="form-check-label"
                for="remember_me">Mantenha-me conectado</label>
            </div>
            <ValidateMessage :error="validateErrors['settings.remember_me']" />
          </div>
        </div>
        <div v-if="value.twofa_type === 'token'">
          <h4 class="mb-3">Verificação de duas etapas.</h4>
          <p>Insira o código de segurança que aparece no seu dispositivo.</p>
          <div class="form-group">
            <label>{{ $t('Código de segurança de seis dígitos.') }}</label>
            <input
              v-autofocus
              type="text"
              class="form-control"
              placeholder="000000"
              v-model="value.twofa_token">
            <ValidateMessage :error="validateErrors.twofa_token" />
          </div>
        </div>
        <div v-if="value.twofa_type === 'recovery_token'">
          <h4 class="mb-3">Recuperação de verificação de duas etapas.</h4>
          <p>Insira a senha de recuperação para desbloquear o acesso a sua conta.</p>
          <div class="form-group">
            <label>{{ $t('Insira a senha de recuperação.') }}</label>
            <input
              v-autofocus
              type="text"
              class="form-control"
              placeholder="0000 0000 0000 0000 0000 0000"
              v-model="value.twofa_recovery_token">
            <ValidateMessage :error="validateErrors.twofa_recovery_token" />
          </div>
        </div>
        <div>
          <div class="mb-3">
            <button
              type="submit"
              class="btn btn-primary">{{ $t('Acessar') }}</button>
          </div>
          <p v-if="!value.twofa_type"><router-link to="/auth/password/new">{{ $t('Esqueci minha senha.') }}</router-link></p>
          <p v-if="value.twofa_type === 'token'"><a href="javascript:void(0)" @click="value.twofa_type = 'recovery_token'">Perdi o acesso ao meu dispositivo 2FA.</a></p>
          <!--<p v-if="value.twofa_type === 'recovery_token'"><a href="javascript:void(0" target="_blank">Perdi minha senha de recuperação.</a></p>-->
          <p v-if="value.twofa_type"><a href="javascript:void(0)" @click="value.twofa_type = null">Voltar para a tela de login.</a></p>
        </div>
      </form>
    </div>
    <div v-if="twofa_recovery_new_token">
      <h4 class="mb-3">{{ $t('New two-factor verification recovery password.') }}</h4>
      <ProfileTwofaSavepass
        :value="twofa_recovery_new_token"
        @checked="redirectToHome"
        recoveryInLogin />
    </div>

    <hr>

    <a
      class="btn btn-block btn-outline-primary"
      :href="googleAuthUrl">
      <span class="d-flex justify-content-center align-items-center">
        <img src="https://www.svgrepo.com/show/50809/google.svg" width="20" class="mr-2">
        <span>Logar com Google</span>
      </span>
    </a>
    <router-link
      class="btn btn-block btn-outline-primary"  
      to="/auth/sso">Logar via SSO</router-link>
  </div>

</template>

<script>
import config from '../../config'
import ProfileTwofaSavepass from '@/components/Profile/ProfileTwofaSavepass'

export default {
  name: 'LoginPass',
  components: {
    ProfileTwofaSavepass
  },
  data () {
    return {
      value: {
        email: null,
        password: null,
        remember_me: false,
        twofa_type: null,
        twofa_token: null,
        twofa_recovery_token: null
      },
      recovery_token_check: false,
      twofa_recovery_new_token: null,
      loading: false,
      validateErrors: false
    }
  },
  metaInfo () {
    return {
      title: this.$t('Login')
    }
  },
  computed: {
    googleAuthUrl () {
      return `${config.api_url}auth/oauth/google?callback_url=${encodeURIComponent(config.app_url + '#/auth/one-time-token')}&try_again_url=${encodeURIComponent(window.location.href)}`
    }
  },
  created () {
  },
  methods: {
    auth (value) {
      this.loading = true

      this.$store.dispatch('authLogin', {
        ...value,
        twofa_token: this.clearToken(value.twofa_token),
        twofa_recovery_token: this.clearToken(value.twofa_recovery_token)
      }).then(result => {
        if (result.twofa_enable) {
          this.value.twofa_type = 'token'
        } else if (result.twofa_recovery_new_token) {
          this.value = {}
          this.twofa_recovery_new_token = result.twofa_recovery_new_token
        } else {
          this.redirectToHome()
        }
      })
      .catch((err) => {
        this.shake()
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      }).finally(() => {
        this.loading = false
      })
    },
    redirectToHome () {
      this.$router.push('/')
    },
    shake () {
      this.$refs.card.classList.add('shake')
      setTimeout(() => {
        this.$refs.card.classList.remove('shake')
      }, 500)
    },
    clearToken (value) {
      if (value) {
        return value.replace(/\s+/g, '')
      }
      return null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/Login.vue